import { render, staticRenderFns } from "./EditPallet.vue?vue&type=template&id=6c22f062"
import script from "./EditPallet.vue?vue&type=script&setup=true&lang=js"
export * from "./EditPallet.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports